export default "__VITE_ASSET__e8e9bb0e__"